import { useEffect, useState } from "react";
import supabase from "../../config/supabase";

export default function Category({ onSelectCategory }) {
  const [categories, setCategories] = useState([]);
  const [activeItem, setActiveItem] = useState("");

  // useEffect(() => {
  //   const fetchCategories = async () => {
  //     try {
  //       const response = await axios.get(
  //         "https://store.annk.info/api/category"
  //       );
  //       setCategories(response.data);
  //     } catch (error) {
  //       console.error("Error fetching categories:", error);
  //     }
  //   };

  //   fetchCategories();
  // }, []);

  useEffect(() => {
  const fetchCategories = async () => {
    const { data, error } = await supabase
      .from("categories")
      .select("*")
      .order("category_name", { ascending: true });

    if (error) {
      console.error(error);
      return;
    }

    setCategories(data);
  };

  fetchCategories();
}, []);

  console.log(categories);

  const handleClick = (e, categoryId) => {
    e.preventDefault();
    setActiveItem(categoryId);
    onSelectCategory(categoryId);
  };

  console.log(activeItem)

  return (
    <>
      <ul>
        {categories.map((category) => (
          <li
            key={category?.id}
            className={activeItem === category?.id ? "active" : ""}
          >
            <a
              href={`#${category?.id}`}
              onClick={(e) => handleClick(e, category?.id)}
            >
              {category.category_name}
            </a>
          </li>
        ))}
      </ul>
    </>
  );
}
